import { render } from "./InternalConversationsCard.vue?vue&type=template&id=289f323b"
import script from "./InternalConversationsCard.vue?vue&type=script&lang=js"
export * from "./InternalConversationsCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__